import { FiDownload, FiExternalLink } from 'react-icons/fi';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import resumePdf from './MacStrommerResume_20260418.pdf';
import resumeImg from './resume-img.png';
import './Resume.css';

const Resume = () => {
  const headerRef  = useScrollReveal();
  const contentRef = useScrollReveal();

  return (
    <section id="resume" className="resume" aria-label="Resume">
      <div className="section-container">
        <div className="section-header reveal" ref={headerRef}>
          <p className="section-label">Credentials</p>
          <h2 className="section-title">Resume</h2>
        </div>

        <div className="resume__content reveal reveal-d1" ref={contentRef}>
          <a
            href={resumePdf}
            target="_blank"
            rel="noreferrer"
            className="resume__preview"
            aria-label="View resume in new tab"
          >
            <img src={resumeImg} alt="Mac Strommer resume preview" className="resume__img" />
            <div className="resume__overlay" aria-hidden="true">
              <FiExternalLink />
              <span>View Full Resume</span>
            </div>
          </a>

          <a
            href={resumePdf}
            download="Mac_Strommer_Resume.pdf"
            className="btn btn-primary resume__download"
          >
            <FiDownload aria-hidden="true" />
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
